import { QRCodeSVG } from 'qrcode.react';

const QR_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/qr`;

// QR on the window sticker → tracked redirect to the car's page
export const StickerQR = ({ vehicleId }) => {
  if (!vehicleId) return null;
  return (
    <div className="flex flex-col items-center shrink-0" data-testid="sticker-qr">
      <p className="text-[10px] font-bold text-blue-900 mb-0.5 whitespace-nowrap">Scannez pour réserver en ligne</p>
      <QRCodeSVG value={`${QR_BASE}/${vehicleId}`} level="M" marginSize={0} style={{ width: '1.5in', height: '1.5in' }} />
    </div>
  );
};
